import { Canvas, CanvasProvider, useCanvasManager } from "@shortsworks/editor";
import { useEffect } from "react";

export const Editor = () => {
  const { activeCanvas } = useCanvasManager();

  useEffect(() => {
    activeCanvas?.controller?.modules?.text.add("SHROTSWORKS");
  }, [activeCanvas]);

  return (
    <div className="flex flex-1 relative w-full h-screen aspect-[9/16]">
      <Canvas id={"111"} ref={null} />
    </div>
  );
};
